import React from 'react';
import { Grid, Card, CardMedia, Typography, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';



export default function ImageThumbnail({ asset, containerStyle, onClick, imageStyle, selected }) {

    const useStyles = makeStyles((theme) => ({
        imageContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 5,
            ...(containerStyle || {})
        },
        image: {
            width: '4rem',
            height: '3rem',
            cursor: 'pointer',
            ...(imageStyle || {})
        },
        selectedImage: {
            width: '4rem',
            height: '3rem',
            cursor: 'pointer',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            ...(imageStyle || {})
        },
        imageName: {
            cursor: 'pointer',
        },
        selectedImageName: {
            cursor: 'pointer',
            backgroundColor: '#48566a',
            color: '#fff'
        }

    }));

    const classes = useStyles();

    const onSelectImage = () => {
        onClick && onClick();
    }

    const assetName = asset?.assetName?.length > 25 ?  asset?.assetName?.slice(0, 25) + '...' : asset?.assetName



    return (
        <Grid item xs={3} className={classes.imageContainer}>
            <Card onClick={onSelectImage}>
                <CardMedia
                    component="img"
                    alt={asset?.assetName}
                    image={asset.url}
                    className={selected ? classes.selectedImage : classes.image}
                />
            </Card>
            <Tooltip title={asset?.assetName}>
                <Typography className={selected ? classes.selectedImageName : classes.imageName} onClick={onSelectImage} variant="caption" align="center">
                    { assetName}
                </Typography>
            </Tooltip>
        </Grid>
    );
};

